var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "appScroll", staticClass: "exchange-detail detail-padding" },
    [
      _c(
        "div",
        {
          staticClass: "spaceBetween",
          staticStyle: { "margin-bottom": "0.32rem", "align-items": "end" },
        },
        [
          _c("div", { staticClass: "spaceLeft" }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "Loan",
                  expression: "activeName == 'Loan'",
                },
              ],
              staticClass: "spaceLeft search-form",
            },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.checkChange },
                  model: {
                    value: _vm.searchParams.checkList,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "checkList", $$v)
                    },
                    expression: "searchParams.checkList",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: "3" } }, [
                    _vm._v("Liquidated"),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: "2" } }, [
                    _vm._v("Warning"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("search-select", {
                attrs: { label: "Repayment status", options: _vm.typeOptions },
                on: {
                  valChange: function ($event) {
                    return _vm.valChange($event, "type")
                  },
                },
              }),
              _vm._v(" "),
              _c("search-date", {
                staticStyle: { "margin-left": "0.2rem" },
                attrs: { label: "Due Date" },
                on: {
                  dateChange: function ($event) {
                    return _vm.dueDateChange($event, "dueDate")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sapceLeft search-item" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "No...",
                      "suffix-icon": "el-icon-search",
                    },
                    on: { change: _vm.getList },
                    model: {
                      value: _vm.searchParams.loanId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "loanId", $$v)
                      },
                      expression: "searchParams.loanId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "Payment",
                  expression: "activeName == 'Payment'",
                },
              ],
              staticClass: "spaceLeft search-form",
            },
            [
              _c(
                "div",
                { staticClass: "sapceLeft search-item" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "No...",
                      "suffix-icon": "el-icon-search",
                    },
                    on: { change: _vm.handleRepaySearch },
                    model: {
                      value: _vm.repaySearchParams.loanId,
                      callback: function ($$v) {
                        _vm.$set(_vm.repaySearchParams, "loanId", $$v)
                      },
                      expression: "repaySearchParams.loanId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("search-date", {
                staticStyle: { "margin-left": "0.2rem" },
                attrs: { label: "Repayment time" },
                on: {
                  dateChange: function ($event) {
                    return _vm.repayDateChange($event, "repayTime")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-card is-border" }, [
        _c("div", { staticClass: "common-card-main" }, [
          _c(
            "div",
            { staticClass: "exchange-tab-box" },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { name: "Loan" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "spaceLeft",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _vm.activeName === "Loan"
                          ? _c("img", {
                              staticStyle: {
                                "margin-right": "0.05rem",
                                width: "0.21rem",
                              },
                              attrs: {
                                src: require("@/assets/image/loan/title-icon.svg"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              staticStyle: {
                                "margin-right": "0.05rem",
                                width: "0.2rem",
                              },
                              attrs: {
                                src: require("@/assets/image/loan/lh-icon.svg"),
                                alt: "",
                              },
                            }),
                        _vm._v("\n              Borrow History\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "Payment" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "spaceLeft",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _vm.activeName === "Payment"
                          ? _c("img", {
                              staticStyle: {
                                "margin-right": "0.05rem",
                                width: "0.2rem",
                              },
                              attrs: {
                                src: require("@/assets/image/loan/rh-active-icon.svg"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              staticStyle: {
                                "margin-right": "0.05rem",
                                width: "0.2rem",
                              },
                              attrs: {
                                src: require("@/assets/image/loan/rh-icon.svg"),
                                alt: "",
                              },
                            }),
                        _vm._v("\n              Repay History\n            "),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "right-text-box" }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName == "Loan"
            ? _c("div", { staticStyle: { padding: "0.3rem 0.4rem" } }, [
                _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        staticClass: "common-table",
                        staticStyle: { width: "100%", "min-width": "1200px" },
                        attrs: { data: _vm.tableList, fit: false },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "loanId",
                            label: "Borrow No.",
                            align: "center",
                            width: "90",
                            "show-overflow-tooltip": true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", { staticClass: "spaceRight" }, [
                                      row.status == 2
                                        ? _c("i", {
                                            staticClass:
                                              "iconfont trn-yujing status-icon is-yujing",
                                            staticStyle: {
                                              "font-size": "0.24rem",
                                            },
                                            attrs: {
                                              "el-tooltip": "",
                                              effect: "dark",
                                              content:
                                                "The collateral Value is below the Low Collatoral Warning Threshold and needs to be replenished.",
                                              placement: "top",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.status == 3
                                        ? _c("i", {
                                            staticClass:
                                              "iconfont trn-qingsuan status-icon is-qingsuan",
                                            staticStyle: {
                                              "font-size": "0.24rem",
                                            },
                                            attrs: {
                                              "el-tooltip": "",
                                              effect: "dark",
                                              content:
                                                "The collateral value is below the Liquidation Threshold and has been liquidated.",
                                              placement: "top",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        " \n                  " +
                                          _vm._s(row.loanId) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1094276939
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "startTime",
                            label: "Date",
                            align: "left",
                            width: "110",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm
                                            .moment(row.startTime * 1000)
                                            .format("YYYY.MM.DD")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1168264476
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "loanAmount",
                            label: "Borrow TCash",
                            align: "right",
                            width: "140",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("big-number", {
                                      attrs: {
                                        number: row.original.loanAmount,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "td-word-sm" }, [
                                      _vm._v("TCash"),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1488863661
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "unitAmount",
                            label: "Collateral",
                            align: "right",
                            width: "140",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("big-number", {
                                      attrs: { number: row.unitAmount },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "td-word-sm" }, [
                                      _vm._v("UNIT"),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            132570363
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "totalDebt",
                            label: "Outstanding",
                            align: "right",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("big-number", {
                                      attrs: { number: row.loanAmount },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "td-word-sm" }, [
                                      _vm._v("TCash"),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1785917498
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dueDate",
                            label: "Due Date",
                            align: "left",
                            width: "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.calculateDueDate(
                                            row.original.startTime
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3313713208
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "status",
                            width: "130",
                            label: "Repayment Status",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", { staticClass: "spaceCenter" }, [
                                      _c("img", {
                                        staticStyle: { width: "0.24rem" },
                                        attrs: {
                                          src: _vm.getRepaymentStatusImg(row),
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "0.1rem",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getRepaymentStatusText(row)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3644063379
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "Operation",
                            width: "200",
                            label: "",
                            align: "left",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "flex-end",
                                          overflow: "auto",
                                          "padding-bottom": "0.1rem",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "o-btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toDetail(row)
                                              },
                                            },
                                          },
                                          [_c("span", [_vm._v("Details")])]
                                        ),
                                        _vm._v(" "),
                                        row.status == 0 || row.status == 2
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "o-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toRepay(row)
                                                  },
                                                },
                                              },
                                              [_c("span", [_vm._v("Repay")])]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        row.status == 2
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "o-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toAddCollate(row)
                                                  },
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Add collateral"),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1974438953
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("pagination", {
                      attrs: {
                        total: _vm.queryParams.total,
                        page: _vm.queryParams.page,
                        limit: _vm.queryParams.pageSize,
                      },
                      on: {
                        "update:total": function ($event) {
                          return _vm.$set(_vm.queryParams, "total", $event)
                        },
                        "update:page": function ($event) {
                          return _vm.$set(_vm.queryParams, "page", $event)
                        },
                        "update:limit": function ($event) {
                          return _vm.$set(_vm.queryParams, "pageSize", $event)
                        },
                        pagination: function ($event) {
                          return _vm.getList()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName == "Payment"
            ? _c(
                "div",
                { staticStyle: { padding: "0.3rem 0.4rem" } },
                [
                  _c("repayPaymentList", {
                    ref: "repayPaymentList",
                    attrs: { searchParams: _vm.repaySearchParams },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("Repayment", { ref: "Repayment", on: { refresh: _vm.repaySuccess } }),
      _vm._v(" "),
      _c("addCollate", { ref: "addCollate", on: { refresh: _vm.refresh } }),
      _vm._v(" "),
      _c("repaySuccessDialog", {
        ref: "repaySuccessDialog",
        on: { success: _vm.refresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }